import { useQueryShopifyTheme } from '~/modules/shopify/hooks/useQueryShopifyTheme';
import { useMemo } from 'react';

import useThemeStore from '~/stores/theme';
import useShopStore from '~/stores/shop';

export const useShopifyThemeInfo = () => {
  const setShopifyTheme = useThemeStore((state) => state.setShopifyTheme);
  const getShopifyThemeId = useThemeStore((state) => state.getShopifyTheme()?.id);
  const shopInfoToken = useShopStore((state) => state.shopInfo?.token);
  const shopifyBaseThemeId = useMemo(() => getShopifyThemeId, [getShopifyThemeId]);
  const shopifyThemeId = useMemo(() => {
    const themeIdMatch = /[^/]+$/.exec(shopifyBaseThemeId ?? '');
    return themeIdMatch ? themeIdMatch[0] : shopifyBaseThemeId;
  }, [shopifyBaseThemeId]);

  useQueryShopifyTheme(undefined, {
    enabled: !!shopInfoToken && !getShopifyThemeId,
    onSuccess: (data) => {
      setShopifyTheme(data);
    },
  });

  return {
    shopifyThemeId,
    shopifyBaseThemeId,
  };
};
